import { Injectable, inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService,  } from '../services/auth.service';

@Injectable()
  export class AuthLoginGuardService {

  constructor(
    private auth: AuthService,
    public router: Router,
  ) { }

  canActivate(url = '/login'): boolean | Promise<boolean | UrlTree> {
    if (this.auth.preservingLegacySession && !this.auth.hasValidLegacySession) {
      this.auth.resumeWithOidc(url);
      return false;
    }
    if (this.auth.shouldUseOidc(url)) {
      return this.auth.oidc.ensureAuthenticated('/').then(authenticated =>
        authenticated ? this.router.parseUrl('/') : false);
    }
    if (!this.auth.isLoggedIn()) {
      return true;
    } 
    
    this.router.navigate(['']);
    return false
  }
}


export const authLoginGuard: CanActivateFn = (route, state) => {
  return inject(AuthLoginGuardService).canActivate(state.url);
};
